define("View",["Module","module"],function(e,i){return e.inherit({namespace:i.id,constructor(e){return this.addClass("View"),this.DOM.loadStylesheet({href:"/View.css"})}})});
//# sourceMappingURL=View.js.map;
